export default __webpack_public_path__ + "static/media/copy.faff6ec8.svg";